import { INITIALIZE_REASSIGN_ADVISOR_FORM } from '../actionTypes';
import { creditsActions } from '../reducer';

export default (values) =>
    creditsActions[INITIALIZE_REASSIGN_ADVISOR_FORM](values);
